import axios from 'axios';
import { Feed, FeedRequest } from './models/Feed';

// ─── API FUNCTIONS ────────────────────────────────────────────────────────────

export const getFeeds = async (
  projectId: string,
  toolId: string,
): Promise<Feed[]> => {
  const { data } = await axios.get<Feed[]>(
    `${window.configuration.apiUrl}api/Feeds/${projectId}/${toolId}`,
  );
  return data;
};

export const createFeed = async (request: FeedRequest): Promise<void> => {
  await axios.post(
    `${window.configuration.apiUrl}api/Feeds`,
    {
      projectId: request.projectId,
      toolId: request.toolId,
      toolProjectId: request.toolProjectId,
      feedName: request.feedName,
      feedScope: request.scope,
    },
    { headers: { 'Content-Type': 'application/json' } },
  );
};

export const deleteFeed = async (request: FeedRequest): Promise<void> => {
  await axios.delete(
    `${window.configuration.apiUrl}api/Feeds`,
    {
      data: {
        projectId: request.projectId,
        toolId: request.toolId,
        toolProjectId: request.toolProjectId,
        feedName: request.feedName,
        feedScope: request.scope,
      },
      headers: { 'Content-Type': 'application/json' },
    },
  );
};

export const validateFeedExists = async (
  toolId: string,
  toolProjectId: string,
  feedName: string,
): Promise<boolean> => {
  const { data } = await axios.get<boolean>(
    `${window.configuration.apiUrl}api/Feeds/validateFeedExists`,
    {
      params: {
        ToolId: toolId,
        ToolProjectId: toolProjectId,
        FeedName: feedName,
      },
    },
  );

  return data;
};
